<template>
  <div
    :class="[
      'flex items-center justify-start gap-x-4',
      full ? 'w-full' : '',
      half ? 'w-1/2' : '',
      justifyBetween ? 'justify-between' : '',
      block ? '!block' : '',
    ]"
    :style="{ marginBottom: marginBottom + 'px', marginTop: marginTop + 'px' }"
  >
    <slot />
  </div>
</template>
<script lang="ts" setup>
  defineProps({
    full: {
      type: Boolean,
      default: true,
    },
    half: {
      type: Boolean,
      default: false,
    },
    justifyStart: {
      type: Boolean,
      default: false,
    },
    justifyBetween: {
      type: Boolean,
      default: false,
    },
    marginBottom: {
      type: Number,
      default: 0,
    },
    marginTop: {
      type: Number,
      default: 8,
    },
    block: {
      type: Boolean,
      default: false,
    },
  });
</script>
